import { languageIdBus } from '@/event/languageIdBus'

const ALLOWED_TAGS = new Set(['p', 'br', 'strong', 'em', 'ul', 'ol', 'li'])

function decodeHTMLEntities(html: string): string {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
}

function sanitizeFragment(html: string): string {
  // On crée le fragment avec les vraies balises
  const decoded = decodeHTMLEntities(html).trim();

  const tpl = document.createElement('template');
  tpl.innerHTML = decoded


  // On parcourt uniquement les vrais éléments
  const walker = document.createTreeWalker(
    tpl.content,
    NodeFilter.SHOW_ELEMENT,
    null
  );
  const toRemove: Element[] = [];
  let node: Node | null = walker.nextNode();

  while (node) {
    const el = node as Element;
    if (ALLOWED_TAGS.has(el.tagName.toLowerCase())) {
      toRemove.push(el);
    }
    node = walker.nextNode();
  }

  // On remplace chaque élément non autorisé par son contenu textuel
  toRemove.forEach(el => {
    const text = document.createTextNode(el.textContent || '');
    el.replaceWith(text);
  });

  return tpl.innerHTML;
}

export const getProductDescription = (product: {
  description: { language_id: number; description: string }[]
}) => {
  if (!product || !product.description) {
    return 'Aucune description'
  }

  let finalDescription

  const description = product.description.find(
    (desc: { language_id: number }) => desc.language_id === languageIdBus.value
  )

  if (description && description.description) {
    finalDescription = sanitizeFragment(description.description)
  }


  return finalDescription ? finalDescription : 'Aucune description'
}
